// Constants extracted from MaturityOnlyResults for reuse

export const MATURITY_BANDS = ['Manual', 'Siloed', 'Managed', 'Controlled', 'Autonomous'] as const;
export type MaturityBand = typeof MATURITY_BANDS[number];

export const BAND_THRESHOLDS = {
  operational: {
    Manual: { min: 6, max: 9 },
    Siloed: { min: 10, max: 14 },
    Managed: { min: 15, max: 19 },
    Controlled: { min: 20, max: 24 },
    Autonomous: { min: 25, max: 30 }
  },
  strategic: {
    Manual: { min: 5, max: 7 },
    Siloed: { min: 8, max: 12 },
    Managed: { min: 13, max: 17 },
    Controlled: { min: 18, max: 21 },
    Autonomous: { min: 22, max: 25 }
  }
} as const;
